/* ============
 * City Transformer
 * ============
 */

import Transformer from './transformer';

export default class SupplierContactTransformer extends Transformer {

  static fetch(item) {
    return {
      id: item.id,
      email: item.email,
      phonenumber: item.phonenumber,
      mobilenumber: item.mobilenumber,
      supplierId: item.supplier_id,
    };
  }

  static send(item) {
    return {
      phonenumber: item.phonenumber,
      mobilenumber: item.mobilenumber,
      supplier_id: item.supplierId,
      email: item.email,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/supplierContact.js